import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoInventoryRequestEmailEditTemplate } from 'themes/application/niko-inventory-request/pages';
import { InventoryRequestEmailEditViewStore } from 'application/inventory-request/stores';

@setCurrentView((rootStore) => new InventoryRequestEmailEditViewStore(rootStore), 'inventoryRequestEmailEditViewStore')
@observer
class NikoInventoryRequestEmailEdit extends React.Component {
    render() {
        return <NikoInventoryRequestEmailEditTemplate {...this.props} />
    }
}

export default NikoInventoryRequestEmailEdit;